import React from "react";

export default function ErrorBoundary({ children, name = "Section" }) {
  const [err, setErr] = React.useState(null);
  
  if (err) {
    return (
      <div className="p-4 rounded-xl border border-white/10 bg-[#111317]">
        <div className="text-brand-gold font-semibold mb-1">{name} failed</div>
        <div className="text-sm text-white/70">Something went wrong. Please try again.</div>
      </div>
    );
  }
  
  return <BoundaryInner onError={setErr}>{children}</BoundaryInner>;
}

function BoundaryInner({ children, onError }) {
  try {
    return <>{children}</>;
  } catch (e) {
    onError(e);
    return null;
  }
}
